import { Link, useLocation } from "react-router-dom";
import { useEffect, useState } from "react";
import { API_BASE_CMS } from "helper/environment";

interface MenuItem {
  id: string;
  attributes: {
    title: string;
    url: string;
    parent: string;
  };
}

function Breadcrumb() {

  const [menuItems, setMenuItems] = useState<MenuItem[]>([]);
  const location = useLocation();
  const currentPath = location.pathname;

  useEffect(() => {
    fetch(`${API_BASE_CMS}/jsonapi/menu_items/main`)
      .then((res) => res.json())
      .then((data) => setMenuItems(data.data));
  }, []);

  // Remove Drupal base path
  const normalize = (url: string) => url.replace("/hreplcmsweb", "");

  // 🔹 Find current menu item
  let currentItem = menuItems.find(
    (item) => normalize(item.attributes.url) === currentPath
  );

  // 🔹 Handle tab pages (Onsite / Offsite)
  if (!currentItem && (currentPath.includes("onsite") || currentPath.includes("offsite"))) {
    currentItem = menuItems.find((item) =>
      normalize(item.attributes.url).includes("commercial")
    );
  }
  if (!currentItem && (currentPath.includes("utility-business"))) {
    currentItem = menuItems.find((item) =>
      normalize(item.attributes.url).includes("utility")
    );
  }
    if (!currentItem && (currentPath.includes("pumped-storage"))) {
    currentItem = menuItems.find((item) =>
      normalize(item.attributes.url).includes("pumped-storage-project")
    );
  }
    let currentItem1 = ""
   if (!currentItem1 && (currentPath.includes("onsite"))) {
    currentItem1 = "onsite";
  }
    else if (!currentItem1 && (currentPath.includes("offsite"))) {
    currentItem1 = "offsite";
  }
  // 🔹 Find parent (Business)
 let parentItem: any = null;
  if(currentItem) {
    parentItem = menuItems.find(
    (item) => item.id === currentItem?.attributes.parent
  );
  }
 
//console.log(parentItem,currentItem,currentPath)
  return (
    <div className="container py-2">
      <nav aria-label="breadcrumb" className="animated slideInDown">
        <ol className="breadcrumb">

          {/* Home */}
          <li className="breadcrumb-item">
            <Link className="text-dark" to="/">
              Home
            </Link>
          </li>

          {/* Parent Menu (Business) */}
          {parentItem && (
            <li className="breadcrumb-item">
             {parentItem && ["Business", "Media"].includes(parentItem?.attributes?.title) ? (
              <span className="text-dark ty">
                {parentItem.attributes.title}
              </span>
            ) : (
              parentItem && (
                <Link
                  className="text-dark ty"
                  to={normalize(parentItem?.attributes?.url)}
                >
                  {parentItem?.attributes?.title}
                </Link>
              )
            )}
             
            </li>
          )}

          {/* Current Section */}
          {currentItem && (
            <li className="breadcrumb-item active">
              
               {currentItem && ["Commercial & Industrial"].includes(currentItem?.attributes?.title) ? (
              <span className="text-dark ty">
                {currentItem.attributes.title}
              </span>
            ) : (
              currentItem && (
                <Link
                  className="text-dark ty"
                  to={normalize(currentItem?.attributes?.url)}
                >
                  {currentItem?.attributes?.title}
                </Link>
              )
            )}
            </li>
          )}
           {currentItem1 && currentItem && (
            <li className="breadcrumb-item active">
               <Link
                className="text-dark ty"
                to={currentPath !== '/commercial-offsite' ? normalize(currentItem.attributes.url) : '' }
              >
              {currentItem1}
              </Link>
            </li>
          )}

        </ol>
      </nav>
    </div>
  );
}

export default Breadcrumb;